import * as React from 'react';
import { IControlOption } from '@cian/ui-kit';

import { IAddress, IAddressSuggestion } from '../../../types/address';

/**
 * enum кодов ошибок, для которых предусмотрена специальная обработка
 */
export { ESpecialFlowValidationErrorCodes as EAddressCadastreSpecialFlowValidationErrorCodes } from '../../../types/requestFormValidation';

export interface IAddressCadastreFieldContainerProps {
  name: string;
}

/**
 * Типы значений
 */
export type TAddressValue = IAddress | null;
export type TCadastreValue = string | null;

export type TAddressCadastreValue =
  | {
      address: IAddress;
      cadastre: null;
    }
  | {
      address: null;
      cadastre: string;
    }
  | null
  | undefined;

/**
 * Типы для вспомогательных хуков полей
 */
export interface IFieldChangeHandler<ValueType> {
  (value: ValueType): void;
}
export interface IUseFieldProps<ValueType> {
  value: ValueType;
  onChange: IFieldChangeHandler<ValueType>;
  onBlur: () => void;
  error?: string;
}

export type TUseAddressSuggestProps = IUseFieldProps<TAddressValue>;

export type TUseCadastreInputProps = IUseFieldProps<TCadastreValue>;

/**
 * Типы пропсов для полей
 */
export interface ICadastreInputProps {
  value: string;
  error?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
}

export interface IAddressSuggestProps {
  value: string;
  error?: string;
  onItemClick(value: IAddressSuggestion): void;
  onChange(value: string): void;
  requestSuggestions(value: string): Promise<IAddressSuggestion[]>;
  onBlur: () => void;
}

/**
 * Типы переключения режима ввода
 */
export enum EInputMode {
  Address = 'address',
  Cadastre = 'cadastre',
}

export type TInputModeOption = IControlOption<EInputMode>;

export interface IUseInputModeProps {
  name: string;
}
export type TUseInputModeResult = [EInputMode, (e: React.ChangeEvent<HTMLInputElement>, value: EInputMode) => void];

export type TUseDefaultInputModeResult = [EInputMode, (value: EInputMode) => void];

/**
 * Типы для основного хука поля
 */
export interface IUseAddressCadastreFieldProps {
  name: string;
}

export interface IInputModeChangeHandler {
  (value: EInputMode): void;
}
export interface IUseAddressCadastreFieldResult {
  value: TAddressCadastreValue;
  touched: boolean;
  inputMode: EInputMode;
  onInputModeChange: IInputModeChangeHandler;
  onAddressChange: IFieldChangeHandler<TAddressValue>;
  onCadastreChange: IFieldChangeHandler<TCadastreValue>;
  onBlur: () => void;
  error?: string;
}

/**
 * Типы для хука маппинга ошибки
 */
export interface IAddressCadastreCustomError {
  address?: string;
  cadastre?: string;
  custom?: React.ReactElement;
}

export interface IUseAddressCadastreCustomErrorProps {
  error?: string;
  inputMode: EInputMode;
  onInputModeChange: IInputModeChangeHandler;
}
